/// <reference path="./image.d.ts" />
import { PageGen, PdfImage } from '../pdf';
import { PdfPen, PdfBrush, PdfRect, PdfPoint } from '../pdf';

PageGen.prototype.drawImageFill = function (image: PdfImage, rect: PdfRect): void {
  const xy = this.getXY(rect.bottomLeft);

  this.page.drawImage(image.image, {
    x: xy.x,
    y: xy.y,
    width: rect.width,
    height: rect.height,
  });
};

PageGen.prototype.drawImageFit = function (image: PdfImage, rect: PdfRect): void {
  const img = image.image;

  const imgW = img.width;
  const imgH = img.height;

  const scale = Math.min(rect.width / imgW, rect.height / imgH);

  const drawW = imgW * scale;
  const drawH = imgH * scale;

  const x = rect.x + (rect.width - drawW) / 2;
  const y = rect.y + (rect.height - drawH) / 2;

  const drawRect = new PdfRect(x, y, drawW, drawH);
  const xy = this.getXY(drawRect.bottomLeft);

  this.page.drawImage(img, {
    x: xy.x,
    y: xy.y,
    width: drawW,
    height: drawH,
  });
};

PageGen.prototype.drawImageCenter = function (image: PdfImage, rect: PdfRect): void {
  this.drawImageFit(image, rect);
};
